import React from "react";

export default function BsFileEarmarkText() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#d)" fill="#currentColor">

        <path
          d="M11.25 8.25C11.25 7.83579 10.9142 7.5 10.5 7.5C10.0858 7.5 9.75 7.83579 9.75 8.25V9.20096L8.92644 8.72548C8.56773 8.51837 8.10903 8.64128 7.90193 9C7.69482 9.35872 7.81773 9.81741 8.17644 10.0245L9 10.5L8.17644 10.9755C7.81772 11.1826 7.69481 11.6413 7.90192 12C8.10903 12.3587 8.56772 12.4816 8.92644 12.2745L9.75 11.799V12.75C9.75 13.1642 10.0858 13.5 10.5 13.5C10.9142 13.5 11.25 13.1642 11.25 12.75V11.799L12.0736 12.2745C12.4323 12.4816 12.891 12.3587 13.0981 12C13.3052 11.6413 13.1823 11.1826 12.8236 10.9755L12 10.5L12.8236 10.0245C13.1823 9.81741 13.3052 9.35872 13.0981 9C12.891 8.64128 12.4323 8.51837 12.0736 8.72548L11.25 9.20096V8.25Z" />
        <path
          d="M8.25 15C7.83579 15 7.5 15.3358 7.5 15.75C7.5 16.1642 7.83579 16.5 8.25 16.5H15.75C16.1642 16.5 16.5 16.1642 16.5 15.75C16.5 15.3358 16.1642 15 15.75 15H8.25Z" />
        <path
          d="M8.25 18C7.83579 18 7.5 18.3358 7.5 18.75C7.5 19.1642 7.83579 19.5 8.25 19.5H15.75C16.1642 19.5 16.5 19.1642 16.5 18.75C16.5 18.3358 16.1642 18 15.75 18H8.25Z" />
        <path
          d="M21 21V6.75L14.25 0H6C4.34315 0 3 1.34314 3 3V21C3 22.6569 4.34315 24 6 24H18C19.6569 24 21 22.6569 21 21ZM14.25 4.5C14.25 5.74264 15.2574 6.75 16.5 6.75H19.5V21C19.5 21.8284 18.8284 22.5 18 22.5H6C5.17157 22.5 4.5 21.8284 4.5 21V3C4.5 2.17157 5.17157 1.5 6 1.5H14.25V4.5Z" />

</g>
  <defs>
    <clipPath id="d">
      <path fill="#fff" transform="translate(0 .082)" d="M0 0h24v24H0z" />
    </clipPath>
  </defs>
</svg>
)
  ;
}
